import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClarityModule } from '@clr/angular';
import { TreeComponent } from './tree/components/tree.component';
import { TreeNodeComponent } from './tree/components/tree-node.component';
import { LoaderComponent } from './tree/components/loader.component';
import { TreeNodeIcon } from './tree/components/tree-node-icon.component';
import { Autofocus } from './auto-focus/auto-focus.directive';
import { ContextMenuDirective } from './context-menu/context-menu.directive';
import { ContextMenuHolderComponent } from './context-menu/context-menu-holder.component';
import { VcaGrid } from './vca-grid/vca-grid.component';
import { IframeResizeDirective } from './iframe-resize.directive';
import { VcaAlerts, VcaAlertsService } from './vca-alerts';
import { VcaGraph } from './vca-graph';
import { VcaJoint } from './vca-joint';
import { IpValidationUtils } from './validations/ip-validation-utils';
import { IPRanges } from './ip-ranges';
import { VcaSpinner } from './vca-spinner/vca-spinner.component';
import { VcaAlarms, VcaAlarmsService } from './vca-alarms';
import { JsonFormComponent, JsonFormInternalComponent } from './json/json-form/json-form.component';
import { JsonComponentService } from './json/json-component.service';
import { UserNamePipe, StoragePrettyRenderPipe, CpuPrettyRenderPipe } from './utils/utils-pipes.pipe';
import { DomUtils }  from './dom/dom-utils';
import { Overlay } from './overlay/overlay.component';
import { AngularSvgIconModule } from './svg-icon';
import { SidebarModule } from './sidebar';
import { Tags } from './tags';

import {
    BasicChartComponent/*,
    LineChartExample,
    TimeSeriesExample,
    BarChartExample,
    PieChartExample*/
} from './charts';

import { BasicChartsDirective } from './charts/directives/basic-charts';
import {
    PositiveNumberValidator,
    EmailListValidator,
    EqualValidator,
    PrefixLengthNumberValidator,
    restrictDecimalValidator,
    MaxLimitValidator,
    MinValueValidator,
    CharLimitValidator
} from './directives';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ClarityModule,
        AngularSvgIconModule,
        SidebarModule.forRoot()
    ],
    providers: [
        VcaAlertsService,
        VcaAlarmsService,
        JsonComponentService,
        DomUtils
    ],
    declarations: [
        TreeComponent,
        TreeNodeComponent,
        LoaderComponent,
        TreeNodeIcon,
        Autofocus,
        ContextMenuDirective,
        ContextMenuHolderComponent,
        VcaGrid,
        IframeResizeDirective,
        VcaAlerts,
        BasicChartsDirective,
        BasicChartComponent,
        // LineChartExample,
        // TimeSeriesExample,
        // BarChartExample,
        // PieChartExample,
        PositiveNumberValidator,
        MaxLimitValidator,
        MinValueValidator,
        CharLimitValidator,
        PrefixLengthNumberValidator,
        restrictDecimalValidator,
        EmailListValidator,
        EqualValidator,
        VcaGraph,
        VcaJoint,
        IPRanges,
        VcaSpinner,
        VcaAlarms,
        JsonFormComponent,
        JsonFormInternalComponent,
        UserNamePipe,
        StoragePrettyRenderPipe,
        CpuPrettyRenderPipe,
        Overlay,
        Tags
    ],
    exports: [
        TreeComponent,
        TreeNodeComponent,
        LoaderComponent,
        TreeNodeIcon,
        Autofocus,
        ContextMenuDirective,
        ContextMenuHolderComponent,
        VcaGrid,
        IframeResizeDirective,
        VcaAlerts,
        BasicChartsDirective,
        BasicChartComponent,
        // LineChartExample,
        // TimeSeriesExample,
        // BarChartExample,
        // PieChartExample,
        PositiveNumberValidator,
        MaxLimitValidator,
        MinValueValidator,
        CharLimitValidator,
        PrefixLengthNumberValidator,
        restrictDecimalValidator,
        EmailListValidator,
        EqualValidator,
        VcaGraph,
        VcaJoint,
        IPRanges,
        VcaSpinner,
        VcaAlarms,
        JsonFormComponent,
        UserNamePipe,
        StoragePrettyRenderPipe,
        CpuPrettyRenderPipe,
        Overlay,
        AngularSvgIconModule,
        SidebarModule,
        Tags
    ]
})
export class VcaCommonModule {
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/common/vcacommon.module.ts